module.exports = __webpack_public_path__ + "img/case2.6cc6253e.png";